import { FC } from 'react'
import {
  BooleanInput, Edit, SelectInput, SimpleForm,
  TextInput, required, useRecordContext,
} from 'react-admin'
import {
  BackToOrgActions, EnvironmentDisplay, LinkUserAccessSection,
  LOG_LEVEL_CHOICES, OrgLinkEditToolbar,
} from '../../components'
import { OrganizationMcpLinkOut } from '../../types/apiRequests'

const McpEnvironmentDisplay: FC = () => {
  const record = useRecordContext<OrganizationMcpLinkOut>()
  if (!record?.environment_display_name) return null
  return <EnvironmentDisplay name={record.environment_display_name} />
}

const OrganizationMcpLinkEdit: FC = () => (
  <Edit
    mutationMode="pessimistic"
    redirect={false}
    actions={<BackToOrgActions tabPath="links" />}
  >
    <SimpleForm toolbar={
      <OrgLinkEditToolbar confirmContentKey="delete.confirmContentMcpLink" tabPath="links" />
    }>
      <McpEnvironmentDisplay />
      <TextInput source="base_url" label="data.baseUrl" fullWidth validate={required()} />
      <BooleanInput source="enabled" label="data.enabled" />
      <SelectInput
        source="log_level"
        label="data.logLevel"
        choices={LOG_LEVEL_CHOICES}
      />
      <LinkUserAccessSection resource="organization_mcp_link" />
    </SimpleForm>
  </Edit>
)

export default OrganizationMcpLinkEdit
